import { NumberFormatValues, NumericFormat } from "react-number-format";
import MxInputField, { MxInputFieldProps } from "./MxInputField";

export interface MxInputThousandFieldProps extends MxInputFieldProps {
  prefix?: string;
  suffix?: string;
  value?: string;
  onChange: (event: {
    target: {
      name: string;
      value: string;
      id: string;
    };
  }) => void;
  afterChangeCallback?: (event: {
    target: {
      name: string;
      value: string;
      id: string;
    };
  }) => void;
}
const MxInputThousandField = (props: MxInputThousandFieldProps) => {
  const { onChange, required, afterChangeCallback, disabled, ...rest } = props;

  const handleChange = (values: NumberFormatValues) => {
    if (onChange) {
      onChange({
        target: {
          id: props.id ?? "",
          name: props.name ?? "",
          value: values.value
        }
      });
    }

    if (afterChangeCallback) {
      setTimeout(() => {
        afterChangeCallback({
          target: {
            id: props.id ?? "",
            name: props.name ?? "",
            value: values.value
          }
        });
      }, 200);
    }
  };
  return (
    <>
      <NumericFormat
        data-testid={`${props.id || props.name}-input-thousand-field`}
        customInput={MxInputField}
        allowLeadingZeros
        allowNegative={false}
        thousandSeparator=","
        onValueChange={handleChange}
        onBlur={props.onBlur}
        label={props.label}
        inputRef={props.inputRef}
        error={props.error}
        value={props.value}
        required={required}
        id={props?.id || props?.name}
        name={props?.name}
        disabled={props.disabled}
      />
    </>
  );
};

export default MxInputThousandField;
